// Tiny pub/sub for cross-component chat events (proactive nudges).
const handlers = new Set();

export function onChatEvent(handler) {
  handlers.add(handler);
  return () => handlers.delete(handler);
}

export function emitChatEvent(event) {
  handlers.forEach((h) => {
    try {
      h(event);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("chatBus handler error", e);
    }
  });
}
